import { PaymentType } from '../../enums/payment-type.enum';

export const PAYMENT_TYPE = {
  [PaymentType.Food]: 'PAYMENTS.VALUES.FOOD',
  [PaymentType.Transport]: 'PAYMENTS.VALUES.TRANSPORT',
  [PaymentType.SchoolFee]: 'PAYMENTS.VALUES.SCHOOL_FEE',
};
